export default __webpack_public_path__ + "static/mobile-apps-image-4-90d5219822e76326cf12ac3aea8ebfe8.jpg";